import {VStack, Heading} from 'platform/foundation';

import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../VehicleForm';

interface WltpPluginHybridConsumptionGroupProps {
  fuelSuffix: string;
}

export function WltpPluginHybridConsumptionGroup(props: WltpPluginHybridConsumptionGroupProps) {
  const fuelSuffix = props.fuelSuffix ?? i18n.t('general.metric.l100km');
  const ELECTRIC_METRIC_SUFFIX = i18n.t('general.metric.kwh100km');
  return (
    <VStack spacing={4}>
      <Heading size={5}>
        {i18n.t('entity.vehicle.labels.fuelConsumptionDischargedBatterySectionTitle')}
      </Heading>
      <VFKit.Group data-testid="fuel-consumption" columns={[1, 2, 4]}>
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpCombined"
          suffix={fuelSuffix}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpCityCenter"
          suffix={fuelSuffix}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpOutskirts"
          suffix={fuelSuffix}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpCountryRoads"
          suffix={fuelSuffix}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpHighway"
          suffix={fuelSuffix}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpWeighted"
          suffix={fuelSuffix}
        />
      </VFKit.Group>

      <Heading size={5}>{i18n.t('entity.vehicle.labels.energyConsumptionSectionTitle')}</Heading>
      <VFKit.Group data-testid="energy-consumption" columns={[1, 2, 4]}>
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpCombinedKwh"
          suffix={ELECTRIC_METRIC_SUFFIX}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpCityCenterKwh"
          suffix={ELECTRIC_METRIC_SUFFIX}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpOutskirtsKwh"
          suffix={ELECTRIC_METRIC_SUFFIX}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpCountryRoadsKwh"
          suffix={ELECTRIC_METRIC_SUFFIX}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpHighwayKwh"
          suffix={ELECTRIC_METRIC_SUFFIX}
        />
        <VFKit.SimpleNumericField
          decimalPlaces={2}
          forceDecimalPlaces
          name="fuelConsumptionWltpWeightedCombinedKwh"
          suffix={ELECTRIC_METRIC_SUFFIX}
        />
      </VFKit.Group>
    </VStack>
  );
}
